// Plain data (no JSX) so this can be imported safely by both the React
// component (src/components/home/HomepageFaq.tsx) and the Node-side
// prerender script / homepageSchema.ts, which build the FAQPage JSON-LD
// from this same array to keep schema and visible copy from drifting.
export const homepageFaqs = [
  {
    question: "What's the difference between Homie's readiness check and a mortgage pre-approval?",
    answer:
      "Homie's readiness check is free and looks at your credit, income, savings, and timeline to give you an honest picture of where you stand — no lender involved. Pre-approval is a formal step you take later, directly with a lender, to get a binding agreement on loan terms.",
  },
  {
    question: "How does the free credit score check and its cashback work?",
    answer:
      "It's a free soft pull — no impact to your score, no lender call. You get $3 cashback just for checking, and Homie explains in plain language which specific factors are pulling your score down and roughly how long they'd realistically take to fix.",
  },
  {
    question: "How does Stack's grant and assistance stacking work?",
    answer:
      "Stack searches every layer of down payment assistance — federal, state, county, and employer programs — and combines every dollar you qualify for into one total, instead of you having to track down one grant at a time on your own.",
  },
  {
    question: "How long does the process typically take?",
    answer:
      "It varies a lot person to person, depending on your credit, savings, and income. Rather than quoting a universal number, Homie gives you an honest, personal estimate based on your actual situation.",
  },
  {
    question: "How does the cashback and rewards funding actually work?",
    answer:
      "You get $3 for the free credit score check, then point payouts as you hit real milestones like pre-approval, down-payment savings, and an accepted offer. Reach 100 points and you unlock VIP perks — and on closing day, Home Approach funds a real cashback check directly to you.",
  },
];
